import { useTranslation } from 'react-i18next';
import { SystemIcon } from '@monorepo/nova-icons';
import { Typography } from '@monorepo/nova-ui';
import {
  StyledAlertButton,
  StyledAlertContainer,
  StyledAlertContent,
  StyledAlertHeader,
} from './payment-required-alert.styled';

export const PaymentRequiredAlert = ({
  amount,
  onCompleteClick,
}: {
  amount: number;
  onCompleteClick: () => void;
}) => {
  const { t } = useTranslation(['dashboardTemplates']);

  return (
    <StyledAlertContainer>
      <StyledAlertContent>
        <StyledAlertHeader>
          <SystemIcon iconName="Warning" />
          <Typography variant="subtitle2" fontWeight={600}>
            {t('dashboardTemplates:payment_required.alert_title')}
          </Typography>
        </StyledAlertHeader>

        <Typography variant="subtitle2" fontWeight={400}>
          {t('dashboardTemplates:payment_required.alert_description', {
            amount,
          })}
        </Typography>

        <StyledAlertButton
          variant="primary"
          size="sm"
          onClick={onCompleteClick}
        >
          {t('dashboardTemplates:payment_required.alert_button')}
        </StyledAlertButton>
      </StyledAlertContent>
    </StyledAlertContainer>
  );
};
